import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { MaskedLines } from "@/components/motion/Reveal";
import { motion, useReducedMotion } from "framer-motion";

export const PageHero = ({ eyebrow, title, lines, intro, crumb, children }) => {
  const reduce = useReducedMotion();
  return (
    <section className="bg-slate text-white grain relative overflow-hidden" data-testid="page-hero">
      <span className="absolute -right-24 -top-24 w-[420px] h-[420px] rounded-full border-[3px] border-copper/25" aria-hidden="true" />
      <div className="container-x relative z-10 pt-14 pb-16 sm:pt-20 sm:pb-24">
        <nav aria-label="Fil d'Ariane" className="flex items-center gap-2 text-sm text-white/60 mb-8" data-testid="breadcrumb">
          <Link to="/" className="hover:text-copper transition-colors">Accueil</Link>
          <ChevronRight size={14} />
          <span className="text-white/90">{crumb}</span>
        </nav>
        {eyebrow && <p className="eyebrow mb-5">{eyebrow}</p>}
        <h1 className="h-display !text-white text-4xl sm:text-5xl lg:text-7xl max-w-4xl" data-testid="page-title">
          {lines ? <MaskedLines lines={lines} /> : title}
        </h1>
        {intro && (
          <motion.p
            initial={reduce ? false : { opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.4 }}
            className="mt-6 max-w-2xl text-base sm:text-lg text-white/75 leading-relaxed"
          >
            {intro}
          </motion.p>
        )}
        {children}
      </div>
    </section>
  );
};
